import styled from 'styled-components';

export const StylesMarker = styled.div`
    transform: translateY(-20px);
`;
